import axios from 'axios';
import configs from '../configs';
const { BASE_URL } = configs;

axios.defaults.withCredentials = process.env.NODE_ENV !== 'development';

export default axios.create({
    baseURL: BASE_URL
});
